import {
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
  TextField,
} from "@material-ui/core";
import React, { useCallback, useState } from "react";
import { TableHeaderColumn } from "react-bootstrap-table";
import { useDataFormatterHook } from "../../../hooks/useDataFormatterHook";
import { dateReportFormatter } from "../../fomatters/DateFormatter";
import { decimalInvertedReportFormatter } from "../../fomatters/DecimalFormatter";
import InputSelect from "../InputSelect";
import Report from "../Report";
import SubGroup from "../SubGroup";

const currentDate = new Date();
currentDate.setMonth(currentDate.getMonth() - 1);

const startDateValue = currentDate.toISOString().split("T")[0];
const endDateValue = new Date().toISOString().split("T")[0];

/**
 * TABLE FREEPLAYOFFICEOPTIONS
 */
function CashFlow() {
  const [startDate, setStartDate] = useState(startDateValue);
  const onStartDateChange = useCallback(
    (event) => setStartDate(event.target.value),
    []
  );

  const [endDate, setEndDate] = useState(endDateValue);
  const onEndDateChange = useCallback(
    (event) => setEndDate(event.target.value),
    []
  );

  const [agent, setAgent] = useState("");
  const onAgentChange = useCallback(
    (event) => setAgent(event.target.value),
    []
  );

  const [distributor, setDistributor] = useState("");
  const onDistributorChanged = useCallback(
    (event) => setDistributor(event.target.value),
    []
  );

  const [player, setPlayer] = useState("");
  const onPlayerChange = useCallback(
    (event) => setPlayer(event.target.value),
    []
  );

  const [higherThan, setHigherThan] = useState("");
  const onHigherThanChanged = useCallback(
    (event) => setHigherThan(event.target.value),
    []
  );

  const [country, setCountry] = useState("");
  const onCountryChanged = useCallback(
    (event) => setCountry(event.target.value),
    []
  );

  const [book, setBook] = useState("");
  const onBookChanged = useCallback((b) => setBook(b), []);
  const { values: books } = useDataFormatterHook({
    addEmpty: true,
    value: "description",
    text: "description",
    path: `/Player/GetBooks`,
  });

  const [group, setGroup] = useState("");
  const onGroupChanged = useCallback((g) => setGroup(g), []);
  const { values: groups } = useDataFormatterHook({
    addEmpty: true,
    value: "groupName",
    text: "groupName",
    path: `/Player/Grouping_GetList`,
  });

  const [office, setOffice] = useState("");
  const onOfficeChanged = useCallback((o) => setOffice(o), []);
  const { values: offices } = useDataFormatterHook({
    addEmpty: true,
    value: "officeName",
    text: "officeName",
    path: `/Player/Office_GetList`,
  });

  const [lineType, setLineType] = useState("");
  const onLineTypeChanged = useCallback((l) => setLineType(l), []);
  const { values: lineTypes } = useDataFormatterHook({
    addEmpty: true,
    value: "description",
    text: "description",
    path: `/LineType/GetLineTypes`,
  });

  const [user, setUser] = useState("");
  const onUserChange = useCallback((u) => setUser(u), []);
  const { values: users } = useDataFormatterHook({
    addEmpty: true,
    value: "loginName",
    text: "loginName",
    path: `/User/GetUsers`,
  });

  const [paymentMethod, setPaymentMethod] = useState("");
  const onPaymentMethodChanged = useCallback((p) => setPaymentMethod(p), []);
  const { values: paymentMethods } = useDataFormatterHook({
    addEmpty: true,
    value: "paymentMethodName",
    text: "paymentMethodName",
    path: `/Player/PaymentMethod_GetList`,
  });

  const [filterByPlayer, setFilterByPlayer] = useState(0);
  const onFilterByPlayerChange = useCallback(
    (event) => setFilterByPlayer(Number(event.target.value)),
    []
  );

  const [filterBy, setFilterBy] = useState(0);
  const onFilterByChange = useCallback(
    (event) => setFilterBy(Number(event.target.value)),
    []
  );

  const [transactionType, setTransactionType] = useState(0);
  const onTransactionTypeChange = useCallback(
    (event) => setTransactionType(Number(event.target.value)),
    []
  );

  const [creditLimit, setCreditLimit] = useState(0);
  const onCreditLimitChange = useCallback(
    (event) => setCreditLimit(Number(event.target.value)),
    []
  );

  return (
    <div className="flex flex-col gap-4 p-4 h-max">
      <div className="grid grid-cols-2 gap-4">
        <TextField
          required
          variant="outlined"
          label="From"
          type="date"
          value={startDate}
          size="small"
          onChange={onStartDateChange}
          InputLabelProps={{ shrink: true }}
        />
        <TextField
          required
          variant="outlined"
          id="gameDateTime"
          label="To"
          type="date"
          value={endDate}
          size="small"
          onChange={onEndDateChange}
          InputLabelProps={{ shrink: true }}
        />
        <InputSelect
          variant="outlined"
          size="small"
          label="Book"
          name="name"
          data={books}
          placeholder="DataFormatter"
          setSelectValue={onBookChanged}
          startValue={""}
        />
        <InputSelect
          variant="outlined"
          size="small"
          label="Group"
          name="name"
          data={groups}
          placeholder="DataFormatter"
          setSelectValue={onGroupChanged}
          startValue={""}
        />
        <InputSelect
          variant="outlined"
          size="small"
          label="Office"
          name="name"
          data={offices}
          placeholder="DataFormatter"
          setSelectValue={onOfficeChanged}
          startValue={""}
        />
        <InputSelect
          variant="outlined"
          size="small"
          label="Line Type"
          name="name"
          data={lineTypes}
          placeholder="DataFormatter"
          setSelectValue={onLineTypeChanged}
          startValue={""}
        />
        <TextField
          required
          variant="outlined"
          label="Agent"
          type="text"
          value={agent}
          size="small"
          onChange={onAgentChange}
          InputLabelProps={{ shrink: true }}
        />
        <TextField
          required
          variant="outlined"
          label="Distributor"
          type="text"
          value={distributor}
          size="small"
          onChange={onDistributorChanged}
          InputLabelProps={{ shrink: true }}
        />
        <TextField
          required
          variant="outlined"
          label="Player"
          type="text"
          value={player}
          size="small"
          onChange={onPlayerChange}
          InputLabelProps={{ shrink: true }}
        />
        <InputSelect
          variant="outlined"
          size="small"
          label="User"
          name="name"
          data={users}
          placeholder="DataFormatter"
          setSelectValue={onUserChange}
          startValue={""}
        />
        <TextField
          required
          variant="outlined"
          label="Higher Than"
          type="number"
          value={higherThan}
          size="small"
          onChange={onHigherThanChanged}
          InputLabelProps={{ shrink: true }}
        />
        <TextField
          required
          variant="outlined"
          label="Country"
          type="text"
          value={country}
          size="small"
          onChange={onCountryChanged}
          InputLabelProps={{ shrink: true }}
        />
        <InputSelect
          variant="outlined"
          size="small"
          label="Payment Method"
          name="name"
          data={paymentMethods}
          placeholder="DataFormatter"
          setSelectValue={onPaymentMethodChanged}
          startValue={""}
        />
        <div>
          <SubGroup title="Filter By Account Type">
            <FormControl component="fieldset">
              <RadioGroup
                label
                value={filterByPlayer}
                onChange={onFilterByPlayerChange}
                row
              >
                <FormControlLabel
                  control={<Radio value={0} size="small" color="primary" />}
                  label="Players"
                  labelPlacement="end"
                />
                <FormControlLabel
                  control={<Radio value={1} size="small" color="primary" />}
                  label="Agents"
                  labelPlacement="end"
                />
                <FormControlLabel
                  control={<Radio value={2} size="small" color="primary" />}
                  label="Both"
                  labelPlacement="end"
                />
              </RadioGroup>
            </FormControl>
          </SubGroup>
        </div>
        <div>
          <SubGroup title="Filter By Date">
            <FormControl component="fieldset">
              <RadioGroup
                label
                value={filterBy}
                onChange={onFilterByChange}
                row
              >
                <FormControlLabel
                  control={<Radio value={0} size="small" color="primary" />}
                  label="Placed Date"
                  labelPlacement="end"
                />
                <FormControlLabel
                  control={<Radio value={1} size="small" color="primary" />}
                  label="Applied Date"
                  labelPlacement="end"
                />
              </RadioGroup>
            </FormControl>
          </SubGroup>
        </div>
        <div>
          <SubGroup title="Transaction Type">
            <FormControl component="fieldset">
              <RadioGroup
                label
                value={transactionType}
                onChange={onTransactionTypeChange}
                row
              >
                <FormControlLabel
                  control={<Radio value={0} size="small" color="primary" />}
                  label="All"
                  labelPlacement="end"
                />
                <FormControlLabel
                  control={<Radio value={1} size="small" color="primary" />}
                  label="Reciept"
                  labelPlacement="end"
                />
                <FormControlLabel
                  control={<Radio value={2} size="small" color="primary" />}
                  label="Disbursement"
                  labelPlacement="end"
                />
                <FormControlLabel
                  control={<Radio value={3} size="small" color="primary" />}
                  label="Transfer"
                  labelPlacement="end"
                />
              </RadioGroup>
            </FormControl>
          </SubGroup>
        </div>
        <div>
          <SubGroup title="Credit Limits">
            <FormControl component="fieldset">
              <RadioGroup
                label
                value={creditLimit}
                onChange={onCreditLimitChange}
                row
              >
                <FormControlLabel
                  control={<Radio value={0} size="small" color="primary" />}
                  label="All"
                  labelPlacement="end"
                />
                <FormControlLabel
                  control={<Radio value={1} size="small" color="primary" />}
                  label="Credit Limit = 0"
                  labelPlacement="end"
                />
                <FormControlLabel
                  control={<Radio value={2} size="small" color="primary" />}
                  label="Credit Limit <> 0"
                  labelPlacement="end"
                />
              </RadioGroup>
            </FormControl>
          </SubGroup>
        </div>
      </div>
      <Report
        title="Cash Flow Report"
        getUrl={() => "/Reports/Report_Cash_Flow"}
        getParams={({ userId }) => ({
          IdUser: Number(userId),
          StartDate: startDate,
          EndDate: endDate,
          Book: book,
          Group: group,
          Office: office,
          LineType: lineType,
          Agent: agent,
          Distributor: distributor,
          Player: player,
          User: user,
          HigherThan: higherThan,
          Country: country,
          PaymentMethod: paymentMethod,
          FilterByPlayer: filterByPlayer,
          FilterBy: filterBy,
          TransactionType: transactionType,
          CreditLimit: creditLimit,
        })}
        getProcess={(data) =>
          data.map((item) => ({
            ...item,
            cash: item.credits + item.debits,
            total: item.credits + item.debits + item.fee + item.bonus,
          }))
        }
        getTotals={(data) => ({
          agent: "Totals",
          cash: data.reduce((acc, item) => acc + item.cash, 0),
          fee: data.reduce((acc, item) => acc + item.fee, 0),
          bonus: data.reduce((acc, item) => acc + item.bonus, 0),
          total: data.reduce((acc, item) => acc + item.total, 0),
        })}
      >
        <TableHeaderColumn dataSort dataField="Id" isKey hidden>
          Id
        </TableHeaderColumn>
        <TableHeaderColumn dataSort dataField="player">
          Account
        </TableHeaderColumn>
        <TableHeaderColumn
          dataSort
          dataField="lastModification"
          dataFormat={dateReportFormatter}
        >
          Date
        </TableHeaderColumn>
        <TableHeaderColumn
          dataSort
          dataField="placedDate"
          dataFormat={dateReportFormatter}
        >
          Placed Date
        </TableHeaderColumn>
        <TableHeaderColumn dataSort dataField="paymentMethod">
          Method
        </TableHeaderColumn>
        <TableHeaderColumn dataSort dataField="description">
          Description/Reference
        </TableHeaderColumn>
        <TableHeaderColumn dataSort dataField="officeName">
          Office
        </TableHeaderColumn>
        <TableHeaderColumn dataSort dataField="bookName">
          Book
        </TableHeaderColumn>
        <TableHeaderColumn dataSort dataField="agent">
          Agent
        </TableHeaderColumn>
        <TableHeaderColumn
          dataSort
          dataField="cash"
          dataFormat={decimalInvertedReportFormatter}
        >
          Cash
        </TableHeaderColumn>
        <TableHeaderColumn
          dataSort
          dataField="fee"
          dataFormat={decimalInvertedReportFormatter}
        >
          Fee
        </TableHeaderColumn>
        <TableHeaderColumn
          dataSort
          dataField="bonus"
          dataFormat={decimalInvertedReportFormatter}
        >
          Bonus
        </TableHeaderColumn>
        <TableHeaderColumn
          dataSort
          dataField="total"
          dataFormat={decimalInvertedReportFormatter}
        >
          Total
        </TableHeaderColumn>
      </Report>
    </div>
  );
}

export default CashFlow;
